import React from "react";

const faqs = [
  {
    question: "Is this the official Formax Pay app?",
    answer:
      "Yes, this is the official Formax Pay application distributed directly by Formax It Solutions Private Limited. You can verify the authenticity by checking the SHA-256 checksum provided above.",
  },
  {
    question: "How can I download Formax Pay app?",
    answer:
      "You can download Formax Pay app directly from our official website. Simply visit our site, follow the installation instructions, and start using the app hassle-free.",
  },
  {
    question: "How do I get future updates?",
    answer:
      "You can download the latest updates directly from the app. Whenever a new version is available, you'll receive a notification within the app to update seamlessly.",
  },
  {
    question: "Is my data safe with this app?",
    answer:
      "Absolutely. We use the same security measures as before, including end-to-end encryption for all transactions. Your data remains protected and private.",
  },
  {
    question: "How can I get support if I need help?",
    answer:
      "Our support team is available 24/7. You can contact us via WhatsApp using the button on this page, email at helpdesk@formaxpay.com, or call us at +91 78900-90-500.",
  },
];

const FAQ = () => {
  return (
    <section id="faq" className="py-5">
      <div className="container py-5">
        <div className="text-center mb-5">
          <h2 className="section-title">Frequently Asked Questions</h2>
          <p className="lead">
            Find answers to common questions about Formax Pay
          </p>
        </div>

        <div className="row justify-content-center">
          <div className="col-lg-8">
            <div className="faq-list">
              {faqs.map((faq, index) => (
                <div
                  key={index}
                  className="mb-4 p-3 border rounded shadow-sm bg-light"
                >
                  <h5 className="mb-2 font-weight-bold">{faq.question}</h5>
                  <p className="text-muted">{faq.answer}</p>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default FAQ;
